@if (redemption()) { @if (redemption()!.blockchain_id) {
<app-crypto-confirm-redemption
  [redemption]="redemption()!"
  (close)="close($event)"
/>
} @else {
<app-coinflow-confirm-redemption
  [redemption]="redemption()!"
  (close)="close($event)"
/>
} } @else { @switch(view()) { @case ('redemption-methods') {
<app-redemption-methods
  (setRedemptionMethod)="setRedemptionMethod($event)"
  (close)="close()"
/>
} @case ('crypto-redemption') {
<app-crypto-redemption
  [amount]="redemptionAmount()"
  (back)="view.set('redemption-methods')"
  (close)="close()"
/>
} @case ('coinflow-redemption') {
<app-coinflow-redemption
  (back)="view.set('redemption-methods')"
  (close)="close()"
  [amount]="redemptionAmount()"
/>
} @case ('venmo-redemption') {
<app-venmo-redemption
  (back)="view.set('redemption-methods')"
  (close)="close()"
  [amount]="redemptionAmount()"
/>
} @default {
<div class="ac-ctr ac-flex" [style.margin]="'auto'">
  <ac-loading [size]="160" />
</div>
} } }
